"use client";
import { Badge, Checkbox } from "@layer/ui/components";
import { ColumnHeader } from "@layer/ui/patterns";
import type { Column, ColumnDef, Row, Table } from "@tanstack/react-table";
import type { MerchantDTO } from "@/api/types/merchants.types";

type GetMerchantSelectColumnsParams = {
	t: any;
};

export const getMerchantSelectColumns = ({
	t,
}: GetMerchantSelectColumnsParams): ColumnDef<MerchantDTO>[] => [
	{
		id: "select",
		size: 40,
		enableSorting: false,
		enableHiding: false,
		header: ({ table }: { table: Table<MerchantDTO> }) => (
			<Checkbox
				checked={
					table.getIsAllPageRowsSelected()
						? true
						: table.getIsSomePageRowsSelected()
							? "indeterminate"
							: false
				}
				onCheckedChange={(value) =>
					table.toggleAllPageRowsSelected(!!value)
				}
				aria-label="Select all"
			/>
		),
		cell: ({ row }: { row: Row<MerchantDTO> }) => (
			<Checkbox
				checked={row.getIsSelected()}
				onCheckedChange={(value) => row.toggleSelected(!!value)}
				aria-label="Select row"
			/>
		),
	},
	{
		accessorKey: "merchantName",
		id: "name",
		header: ({ column }: { column: Column<MerchantDTO> }) => (
			<ColumnHeader column={column} title={t("merchants.table.name")} />
		),
		cell: ({ row }: { row: Row<MerchantDTO> }) => (
			<div className="flex items-center gap-2 text-sm">
				{row.original.merchantLogo && (
					<img
						src={row.original.merchantLogo}
						alt={row.original.merchantName}
						className="size-6 rounded object-cover"
					/>
				)}
				{row.original.merchantName}
			</div>
		),
	},
	{
		accessorKey: "merchantId",
		id: "merchantId",
		header: ({ column }: { column: Column<MerchantDTO> }) => (
			<ColumnHeader
				column={column}
				title={t("merchants.table.merchantId")}
			/>
		),
		cell: ({ row }: { row: Row<MerchantDTO> }) => (
			<span className="text-sm">{row.original.merchantId}</span>
		),
	},
	{
		accessorKey: "status",
		id: "status",
		header: ({ column }: { column: Column<MerchantDTO> }) => (
			<ColumnHeader column={column} title={t("merchants.table.status")} />
		),
		cell: ({ row }: { row: Row<MerchantDTO> }) => (
			<div className="py-1">
				<Badge className="capitalize">
					{row.original.status.toLowerCase()}
				</Badge>
			</div>
		),
	},
];
